module.exports = __webpack_public_path__ + "static/media/hamburguesa-white.752e6515.svg";